module.exports = __webpack_public_path__ + "static/img/award4_a.f76b37f.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/index/award4_a.png
// module id = ALiw
// module chunks = 7